(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FormsController', FormsController);
    window.localStorage.removeItem("DataTables_nasracformsbar_/");
    FormsController.$inject = ['$scope', '$filter','$state', 'DataUtils', 'Forms', 'paginationConstants', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$compile','AuthServerProvider','Principal'];

    function FormsController ($scope, $filter, $state, DataUtils, Forms, paginationConstants,  $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $compile ,AuthServerProvider, Principal) {
        var vm = this;
        vm.Forms=[];
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.hasAuthority= Principal.hasAuthority();
        vm.dtInstance = {};

        var adminAuthorities = ['Administrators'];

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                contentType: 'application/json',
                url: '/api/forms/datatables-view',
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader("Authorization",
                        "Bearer " + AuthServerProvider.getToken());
                },
                data: function(data, dtInstance) {
                    // The returned object has 'email' as property, but the server entity has 'emailAddress'
                    // We need to override what we ask to the server here otherwise search will not work
//                data.columns[1].data = "emailAddress";
                    //data.columns.shift();
                    //data.columns.splice(7);
                    data.columns.shift();


                    /*if($scope.DocumentType && $scope.DocumentType.length>0 && $scope.DocumentType != ""){
                        data.search.value = $scope.DocumentType;
                    } else {
                        data.search.value = "";
                    }*/
                    data.order[0].column = data.order[0].column - 1;

                    // Any values you set on the data object will be passed along as parameters to the server
                    //data.access_token = AuthenticationService.getAccessToken();
                    return JSON.stringify(data);
                }

            })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-2'l><'col-sm-3'B><'col-sm-2 pull-right'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrap()
            .withPaginationType('full_numbers')
            .withDisplayLength(25)
            .withButtons( [
            {
                extend: 'collection',
                text: ' Select Document Type',
                autoClose: true,
                responsive: true,
                buttons: [
                    {
                        text: 'All Documnets',

                        action: function ( e, dt, node, configc,$state ) {
                            dt.columns(2).search( '' ).draw();
                        }
                    },
                    {
                        text: 'Channel Map',
                        action: function ( e, dt, node, config ) {
                            dt.columns(2).search( 'Channel Map' ).draw();
                        }

                    },
                    {
                        text: 'Launch Document',
                        action: function ( e, dt, node, config ) {
                            dt.columns(2).search( 'Launch Document' ).draw();
                        }

                    },{
                        text: 'Other',
                        action: function ( e, dt, node, config ) {
                            dt.columns(2).search( 'Other' ).draw();
                        }

                    },

                ]
            }
        ])
            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            .withOption('order', [1, 'asc']);

            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '115px').notSortable()
                    .renderWith(actionsHtml),
                DTColumnBuilder.newColumn('title').withTitle('Title'),
                DTColumnBuilder.newColumn('doctype').withTitle('Type'),
                DTColumnBuilder.newColumn('description').withTitle('Description'),
                DTColumnBuilder.newColumn('filesize').withTitle('Size'),
                DTColumnBuilder.newColumn('uploaddate').withTitle('Uploaded date'),
                DTColumnBuilder.newColumn('uploadedby').withTitle('Uploaded by'),
                DTColumnBuilder.newColumn('noofdownloads').withTitle('No.Of Downloads'),
                DTColumnBuilder.newColumn('docvisibility').withTitle('Visibility'),
            ];


            if (Principal.hasAnyAuthority(adminAuthorities)){
            	vm.dtColumns[6].visible = true;
                vm.dtColumns[7].visible = true;
                vm.dtColumns[8].visible = true;
            } else {
            	vm.dtColumns[0].withOption('width', '55px');
            }

            vm.dtColumns[5].renderWith(function (data, type, full) {
                return $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ') + abbr;   // Angularjs date filter
            });


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }
        function actionsHtml(data, type, full, meta){
    		if(Principal.hasAnyAuthority(adminAuthorities)){
                return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete','download']);
            } else {
            	 return GUIUtils.getActionsTemplate(data, $state.current.name, ['download']);
            }
        }

        function transition() {

            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });

        }

    }
})();
